import React from 'react';

function LogoutIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M11.9,10c0,2.3,0,4.7,0,7c0,1.3-0.6,2.2-1.7,2.7c-0.6,0.3-1.3,0.3-2,0.1c-2-0.6-3.9-1.2-5.9-1.8c-1.3-0.4-2.1-1.5-2.1-2.8c0-3.6,0-7.1,0-10.7c0-1.3,0.8-2.4,2.1-2.8c1.9-0.6,3.8-1.2,5.8-1.7c1.9-0.6,3.8,0.8,3.8,2.8C11.9,5.3,11.9,7.6,11.9,10z M8.1,10c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1C7.6,11,8.1,10.5,8.1,10z"/>
        <path d="M16.4,9c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.4-0.3-1,0-1.3C16.5,7,17,7,17.4,7.3c0.6,0.6,1.2,1.2,1.8,1.8c-0.1,0-0.2-0.1-0.3-0.1c0,0,0,0,0,0c0.1,0,0.2,0.1,0.3,0.1c0.6,0.2,0.8,0.9,0.4,1.4c0,0-0.1,0.1-0.1,0.1c-0.6,0.6-1.3,1.3-1.9,1.9c-0.3,0.3-0.6,0.4-1,0.3c-0.4-0.1-0.6-0.4-0.7-0.7c-0.1-0.3,0-0.6,0.2-0.8c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.2,0-0.3,0c-0.8,0-1.5,0-2.3,0c-0.5,0-0.9-0.4-0.9-0.9c-0.1-0.5,0.2-0.9,0.7-1c0.1,0,0.3,0,0.4,0C14.8,9,15.5,9,16.4,9z"/>
        <path d="M15.4,18.7c-0.5,0-1,0-1.5,0c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.9,0,1.8,0,2.7,0c0.7,0,1.1-0.4,1.1-1.1c0-0.3,0-0.6,0-0.9c0-0.5,0.4-0.9,1-0.9c0.5,0,1,0.4,1,1c0,0.6,0,1.2-0.1,1.7c-0.3,1.3-1.4,2.1-2.7,2.2C16.4,18.7,15.9,18.7,15.4,18.7z"/>
        <path d="M15.4,1.3c0.6,0,1.2-0.1,1.8,0c1.4,0.2,2.4,1.4,2.4,2.7c0,0.4,0,0.7,0,1.1c0,0.6-0.4,1-1,1c-0.5,0-0.9-0.4-1-1c0-0.3,0-0.6,0-0.9c0-0.6-0.4-1-1-1c-0.9,0-1.8,0-2.7,0c-0.1,0-0.3,0-0.4-0.1c-0.4-0.1-0.7-0.6-0.6-1c0.1-0.5,0.5-0.8,0.9-0.8C14.4,1.3,14.9,1.3,15.4,1.3C15.4,1.3,15.4,1.3,15.4,1.3z"/>
      </g>
    </svg>
  );
}

export default LogoutIcon;
